import { S as Swiper } from './classes-to-selector-6ijYtnfY.js';
import { N as Navigation } from './navigation-D3ssu5k4.js';
import { P as Pagination } from './pagination-6ibxO3Ub.js';
import { S as Scrollbar } from './scrollbar-CigCyCA3.js';
import { A as A11y } from './a11y-DZ2R8bcp.js';
import { A as Autoplay } from './autoplay-C12qvRhh.js';

class ContentSwiper extends HTMLElement {
  connectedCallback() {
    this.swiper = this.querySelector('[data-swiper]');
    // Stop when the swiper is not found
    if (!this.swiper) {
      return;
    }

    // Default to improve user experience
    this.swiperOptions = {
      modules: [A11y, Navigation, Pagination, Scrollbar, Autoplay],
      threshold: 10,
    };

    // Check if we have extra options on the HTML
    if (this.swiper.dataset.options) {
      const options = JSON.parse(this.swiper.dataset.options);
      if (options) {
        this.swiperOptions = {
          ...this.swiperOptions,
          ...options,
        };
      }
    }

    // Call swiper with selected swiper element and options
    this.swiperInstance = new Swiper(this.swiper, this.swiperOptions);

    this.swiperInstance.on('activeIndexChange', (event) => {
      this.updatePagination(event.activeIndex + 1);
      this.updateCaptionText(event);
    });

    /**
     * Listen to extra events when in Shopify editor
     */
    if (Shopify.designMode) {
      // Update the swiper when the section event is triggerd
      window.addEventListener('shopify:section:load', () => {
        this.swiperInstance.update();
        if (this.swiperOptions.navigation) {
          this.swiperInstance.navigation.init();
          this.swiperInstance.navigation.update();
        }
      });

      // When on block select go to the slide in front-end
      window.addEventListener('shopify:block:select', (event) => {
        this.swiperInstance.update();
        if (this.swiperOptions.navigation) {
          this.swiperInstance.navigation.init();
          this.swiperInstance.navigation.update();
        }
        this.handleBlockSelect(event);
      });

      // When on block deselect go to the slide in front-end
      window.addEventListener('shopify:block:deselect', (event) => {
        this.swiperInstance.update();
        if (this.swiperOptions.navigation) {
          this.swiperInstance.navigation.init();
          this.swiperInstance.navigation.update();
        }
        this.handleBlockSelect(event);
      });
    }
  }

  /**
   * Handles the theme editor block change/edit event
   * @param {Object} event
   */
  handleBlockSelect(event) {
    // Check if the slide index is set
    if (!('swiperSlideIndex' in event.target.dataset)) {
      return;
    }

    // Set the slide index based on loop settings or not
    let swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) - 1;
    if (this.swiperOptions.loop) {
      swipeToSlideIndex = parseInt(event.target.dataset.swiperSlideIndex) + 1;
    }

    // Slide to slide based on the data attribute from the target
    const sliderToUpdate = event.target.closest('[data-swiper]');
    sliderToUpdate.swiper.slideTo(swipeToSlideIndex, 1000);
  }

  /**
   * updatePagination
   * @param {Number} activeSlide
   */
  updatePagination(activeSlide) {
    const index = this.querySelector('[data-number-slides]');
    console.log(index);
    if (index) {
      index.innerHTML = activeSlide;
    }
  }

  /**
   * updateCaptionText
   * @param {swiperInstance} swiper
   */

  updateCaptionText(swiper) {
    const currentSlide = swiper.slides[swiper.activeIndex];
    const activeText = this.querySelector('[data-active-slide-text]');
    if (activeText && currentSlide) {
      const richText = currentSlide.getElementsByTagName('div')[0];
      activeText.innerHTML = richText.innerHTML;
    }
  }
}

customElements.define('content-swiper', ContentSwiper);
